/* eslint-disable complexity */
/* eslint-disable no-restricted-imports */
/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMMultiAddToCartPayload } from '@/data/types/GTM';
import { extractPartNumberFather } from '@/data/utils/extractPartNumberFather';
import { findProductAttribute } from 'integration/utils/findProductAttribute';
import getValueByPathFromUnknown from 'integration/utils/getValueByPathFromUnknown';
import { getAvailableProductSizes } from 'integration/utils/getAvailableProductSizes';
import { mergeRibbonsForProduct } from '@/utils/mergeRibbonsForProduct';

// eslint-disable-next-line complexity
export const getGTMMultiAddToCartEventData = async (payload: GTMMultiAddToCartPayload) => {
	const { availability, products, from_look, look_id, look_name } = payload;

	const items = products.map((product) => {
		const { name: item_name, partNumber: item_id, productPrice } = product ?? {};
		const currency = productPrice?.currency ?? '';
		const value = productPrice?.offer;
		const list = productPrice?.list;

		const item_brand = findProductAttribute(product?.attributes ?? [], 'Marca')?.value;
		const item_talla = getValueByPathFromUnknown(product.attributes, ['Talla']);
		const item_category = findProductAttribute(product?.attributes ?? [], 'Genero')?.value;
		const item_category1 = findProductAttribute(product?.attributes ?? [], 'Familia')?.value;
		const item_category2 = findProductAttribute(product?.attributes ?? [], 'Uso')?.value;
		const item_tallas_disponibles = getAvailableProductSizes(product, availability);
		const item_ribbons = mergeRibbonsForProduct(product?.ribbons ?? []).flatMap(
			(ribbon) => ribbon.value
		);
		const availableQuantity = availability?.length ? Number(availability[0].availableQuantity) : 0;
		const item_pocas_piezas = availableQuantity > 0 && availableQuantity < 15 ? 'Si' : 'No';
		const item_tipo_precio = (value ?? 0) > 0 && value !== (list ?? 0) ? 'Oferta' : 'Full price';
		const item_color = findProductAttribute(product?.attributes ?? [], 'Color1')?.value;

		return {
			item_id,
			item_group_id: extractPartNumberFather(item_id),
			item_name,
			coupon: 'N/A',
			discount:
				(productPrice?.list ?? 0) > (productPrice?.offer ?? 0)
					? (productPrice?.list ?? 0) - (productPrice?.offer ?? 0)
					: 0,
			affiliation: 'Dportenis',
			item_brand,
			item_category,
			item_category1,
			item_category2,
			item_variant: product?.keyword,
			price: Number(productPrice?.offer),
			currency,
			quantity: 1,
			type: product?.type,
			item_talla,
			item_tallas_disponibles,
			item_tallas_cantidad: item_tallas_disponibles.length.toString(),
			item_color,
			item_tipo_precio,
			item_ribbons,
			item_pocas_piezas,
		};
	});

	return { ecommerce: { items }, from_look, look_id, look_name };
};
